<template>
	<div>
		<header-nav :cur="10" />
		<our-nav />
		<!-- 个人列表 -->
		<div class="navtab listbox">
			<div class="leftbox">
                <div class="list" v-for="(item, index) in listnav" :key="index" @click="toright(index, item.name)">
                  <img :src="item.img" alt="" />
                  <span :class="{ active: index == activeindex }">{{ item.name }}</span>
                </div>
            </div>
            <div class="rightbox">
              <div class="name" v-if="activeindex == 5">{{ name || '我的订单' }}</div>
              <div class="name" v-else>{{ name || '个人中心' }}</div>

              <!-- 个人信息 -->
              <div class="content ourbox" v-if="activeindex == 0">
                <div v-if="!alterour" class="ourbox">
                  <div class="ourleft">
                    <van-uploader  :after-read="setups" :max-size="10240 * 1024" ref="uploadFile" accept="image/*" class="arrart" title="上传头像">
                      <img  width="60" height="60"   :src="userImg==null || userImg=='' ||  userImg=='undefined' ? url:$api.url+userImg" alt="" />
                     </van-uploader>
                            <!--<img :src="url" alt="" />-->
							<div class="ourleftlist">
								<div>姓&emsp;&emsp;名：{{userName}}</div>
								<div>身份证号：{{userIdcard}}</div>
								<div>联系电话：{{mobile}}</div>
							</div>
						</div>
						<div class="ourright" @click="toourdetail()">修改密码</div>
					</div>
					<!-- 个人信息修改 -->
					<div class="alterour" v-if="alterour">

						<div class="headright" >
							<div class="list">
								旧密码：
								<input type="password" :placeholder="请输入旧密码" v-model="userPwd.oldPassWd" />
							</div>
							<div class="list">
								新密码：
								<input type="password" :placeholder="请输入新密码" v-model="userPwd.newPassWd" />
							</div>
							<div class="list">
								新密码：
								<input type="password" :placeholder="再次输入新密码" v-model="userPwd.snewPassWd" />
							</div>
              <div class="submit" @click="toourdetails()" style="width: 150px; background-color: #6a6a6a; margin-left: 10px">返回</div>
							<div class="submit" @click="updatePassword()">保存修改</div>
						</div>
					</div>
				</div>
				<!-- 我的消息 -->
				<div class="messages" v-if="activeindex == 1">
					<div class="messagesList" v-for="(item,index) in notice_list" :key="index">
						<div class="messagesTitle">{{item.title}}</div>
						<div class="messagesTime">{{item.createTime}}</div>
						<div class="messagesCon" v-html="item.content">
						</div>
					</div>
					<v-pagination :total="notice_total" :display='queryNoticeParams.pageSize'
						:current-page='queryNoticeParams.pageNum' @pagechange="pageNoticeChange"
						style="padding-top: 80px;"></v-pagination>

				</div>

				<!-- 培训信息 -->
				<div class="apply" v-if="activeindex == 2">
					<div class="listbox" v-for="(item,index) in my_clazz_list" :key="index">
						<div class="secodebox">
							<img :src="$api.url+item.clazzImage" alt="" />
							<div>
								<div class="title" >
									{{item.clazzName}}培训
									<span class="color1"  v-if="item.bmfl=='1' || item.bmfl=='1,2'">公需课:{{item.public_course_hours}}学时</span>
									<span class="color2"  v-if="item.bmfl=='2' || item.bmfl=='1,2'">专业课:{{item.special_course_hours}}学时</span>
								</div>
								<div class="time">
									<span style="color: #ff3300">￥{{item.clazzPrice}}</span>
									<span>培训开始时间：{{item.startTime}}</span>
									<span>培训结束时间：{{item.endTime}}</span>
								</div>
								<div class="tent ignore">
									培训简介：<span v-html="item.clazzDescribe"></span>
								</div>
							</div>
						</div>
						
						
						<div class="bottom coloragin" v-if="item.userClazz == null">
							<img src="../../assets/img/our/grxx_zt_2.svg" alt="" />
							未报名
							<!-- <div class="agin fees" @click="startReport(item.id)">开始报名</div> -->
						</div>
						<!--提交成功待审核时代码 -->
						
						
						<!-- <div class="bottom" v-if="item.userClazz != null && item.userClazz.state == '2'"
							>
							<img src="../../assets/img/our/grxx_zt_1.svg" alt="" />
							<div class="agin fees" style="cursor: pointer;background-color: blue;" @click="createPayCodeUrl(item.userClazz.id,item.userClazz.clazzName,item.clazzPrice)">报名缴费</div>
							<div class="agin fees" style="cursor: pointer;background-color: chocolate;font-size: 15px;line-height: 35px;"  @click="closeClazzUser(item.userClazz.id)">取消报名</div>
						</div> -->
						
						
						<!-- 为审核未通过时代码 -->
						<!-- <div class="bottom coloragin">
                      <img src="../../assets/img/our/grxx_zt_2.svg" alt="" />
                      审核未通过
                      <div class="agin">重新提交</div>
                  </div> -->
						<!-- 为申请成功时代码  -->
						<div class="bottom colorfees" v-if="item.userClazz != null && item.userClazz.state == '1'">
							<img src="../../assets/img/our/grxx_zt_3.svg" alt="" />
							报名成功，已缴费
						</div>
					</div>

					<v-pagination :total="my_clazz_total" :display='queryClazzParams.pageSize'
						:current-page='queryClazzParams.pageNum' @pagechange="pageClazzChange"
						style="padding-top: 80px;"></v-pagination>

				</div>

        <!-- 我的课程 -->
				<div class="content" v-if="activeindex == 3">
					<div class="couse">
						<div class="cousebox" v-for="(item, index) in my_course_list" :key="index" @click="toCourseDetail(item.id)" style="cursor:pointer" >
							<img :src="$api.url+item.courseImage" :alt="item.courseName" />
							<div class="imgright">
								<div class="name1">{{ item.courseName }}</div>
								<div class="student">
									学习进度{{showPercent (item.percent)}}%
									<van-progress color="#2961EF" stroke-width="9" :percentage="showPercent (item.percent)" />
								</div>
								<!-- <div class="conteal">
									继续学习
									<img src="../../assets/img/our/grzx_icon_tb (1).svg" alt="" />
								</div> -->
							</div>
						</div>
					</div>
					<v-pagination :total="my_course_total" :display='queryMyCourseParams.pageSize'
						:current-page='queryMyCourseParams.pageNum' @pagechange="pageCourseChange"></v-pagination>
				</div>

				<!-- 证书申请 -->
				<div class="certificate" v-if="activeindex == 4">
					<div  class="component-wrapper"  style="width: 100%;padding-top: 10px;padding-bottom: 100px;">
						<component :is="currentView" :key="currentView"></component>
					</div>
					
					<!-- <div class="cerlist">
						<div class="title">甘肃省{{year}}年度专业技术人员继续教育培训证书申请</div>
						<div class="time zhengshulist">
							<span>1、按人社厅要求证书统一由"甘肃省专业技术人员继续教育工作平台"管理发放；</span>
							<span>2、请在确认自己完成培训学习后（公需课学时满30学时，总学时满90学时），点击下面"提交学时，申请证书"按钮；</span>
                            <span>3、学时提交成功后，请登录"甘肃省专业技术人员继续教育工作平台"官网（http://gsjxjy.rst.gansu.gov.cn/）或通过甘快办证照查询功能进行证书查询和下载打印。</span>
							<span>
								<a @click="submitCreditHours()"><img src="../../assets/img/our/grzx_ck.svg" alt="" />提交学时，申请证书</a>
							</span>
						</div>
					</div> -->
				</div>

				<!-- 我的订单 -->
			   <div class="myPay" v-if="activeindex == 5"   > 
				<el-table
				      :data="order_list"
				      style="width: 100%">
					  <el-table-column
					    prop="clazzName"
					    label="订单名称"
					    width="100">
					  </el-table-column>
					  <el-table-column
					    prop="year"
					    label="年份"
					    width="100">
					  </el-table-column>
				      <el-table-column
				        prop="order_price"
				        label="订单价格"
				        width="180">
				      </el-table-column>
				      <el-table-column
				        prop="order_create_time"
				        label="订单创建时间">
				      </el-table-column>
					  <el-table-column
					    prop="order_pay_time"
					    label="支付时间">
					  </el-table-column>
					  
				</el-table>
				<!-- <div class="myPayList" v-for="(item,index) in order_list" :key="index">
					<p><span>订单名称</span><a>2023年甘肃省继续教育培训</a></p>
					<p><span>订单id</span><a>{{item.order_id}}</a></p>
					<p><span>订单金额</span><a>¥ {{item.order_price}}</a></p>
					<p><span>创建时间</span><a>{{item.order_create_time}}</a></p>
					<p><span>支付时间</span><a>{{item.order_pay_time}}</a></p>
                <div> -->
				 <!-- <a @click="myPayInvoice(item.order_id)" v-if="item.invoice_apply_state=='0'">发票申请</a>
			     <a @click="myPayInvoice(item.order_id)" v-if="item.invoice_apply_state=='1'">查看开票信息</a> -->
			
					<v-pagination :total="order_total" :display='queryOrderParams.pageSize'
						:current-page='queryOrderParams.pageNum' @pagechange="pageNoticeChange"
						style="padding-top: 80px;padding-bottom: 50px;"></v-pagination>
						<br/><br/><br/><br/>
			  </div>
			  
			  
			  
			  <!-- 证书申请 -->
			  <div class="certificate" v-if="activeindex == 6">
			  	<div  class="component-wrapper"  style="width: 100%;padding-top: 10px;padding-bottom: 100px;">
			  		<component :is="currentExamView" :key="currentExamView"></component>
			  	</div>
			
			  </div>
			  
			  
			  
			  
			</div>

		</div>
		<footer-nav />

    <div class="model2" v-show="isShowMultiple">
      <div class="modelFixed" ref="child">
				<span>{{bmmc}}<br />报名缴费<br />
					<font>¥{{ bmjg}}</font>
				</span>
        <img :src=" 'data:image/png;base64,' + payCodeUrl " width="250px" height="250px">
        <p>请使用微信扫描二维码支付,如您已缴费、刷新此页面后开始学习。</p>
        <a @click="endReport()">×</a>
      </div>
    </div>

    <div class="model2" v-show="isShowMyPay">
      <div class="myPayInvoice" v-for="(item,index) in order_list" :key="index">
		<p><span>订单名称</span><span>{{year}}年甘肃省继续教育培训</span></p>
        <p><span>订单id</span><span>{{item.order_id}}</span></p>

        <p><span>订单金额</span><span>¥ {{item.order_price}}</span></p>
        <p><span>创建时间</span><span>{{item.order_create_time}}</span></p>
        <p><span>支付时间</span><span>{{item.order_pay_time}}</span></p>
        <div>暂不提供电子发票，请如实填写开票信息及收件地址，开具纸质发票后以快递方式寄出，快递费到付。</div>
        <input class="invoiceBtn" type="submit" value="提交申请" @click="submitInvoice(item.id)" v-if="item.invoice_apply_state=='0'"/>
        <a @click="closeOpo()">×</a>
      </div>
    </div>

  </div>
</template>
<script>
	import Vue from 'vue';
    import {ref} from 'vue';
	import {Progress} from 'vant';
	import pagination from '@/components/common/pagination'
    import {uploadFile, updateUser, getMyHeaderImage} from '@/api/updateImg'
	Vue.use(Progress);
	import {
		encrypt,
		decrypt
	} from '../../config/jsencrypt'
	import http from '@/utils/http.js'
	import common from '@/config/common.js'

	import headerNav from '../../components/HeaderNav.vue';
	import ourNav from '../../components/OurNav.vue';
	import footerNav from '../../components/FooterBar';
	import {queryLoginState} from '@/api/login.js'
	import {startReport,queryClazzList,submitStudyHonours,cancelClazzStudentById} from '@/api/clazz.js'
	import {queryNoticeList,queryNoticeById} from '@/api/notice.js'
	import {queryCertificateList} from '@/api/cerft.js'
	import {createPayCodeUrl,checkOrderIsPay} from '@/api/pay.js'
    import {submitInvoice,querymyOrderList} from '@/api/order.js'
	import {updatePassword} from '@/api/login.js'
	import {querymyCourseList} from '@/api/course.js'
    import {queryClazzUserInfo,queryUserSchoolHours,queryClazzReportState} from '@/api/user.js'
    import axios from "axios";
    import md5 from 'js-md5';
	import submitHours from './submitHours'
	import examHistory from './examHistory'
  //const message = ref("小猪课堂");
	export default {
		components: {
			pagination,
			headerNav,
			footerNav,
			ourNav,
			submitHours,
			examHistory
		},
		data() {
			return {
				currentView:'submitHours',
				currentExamView:'examHistory',
                url: require("../../assets/img/index/userLog.jpeg"),
				alterour: '',
				such: 0,
				isdread: false,
				name: '',
				activeindex: 1,
				listnav: [{
						img: require('../../assets/img/our/1.svg'),
						name: '个人信息'
					},
					{
						img: require('../../assets/img/our/4.svg'),
						name: '我的消息'
					},
					{
						img: require('../../assets/img/our/7.svg'),
						name: '培训报名'
					},
					{
						img: require('../../assets/img/our/3.svg'),
						name: '学习记录'
					},
					{
						img: require('../../assets/img/our/6.svg'),
						name: '证书申请'
					},
					{
						img: require('../../assets/img/our/2.svg'),
						name: '我的订单'
					},
					{
						img: require('../../assets/img/our/2.svg'),
						name: '考试记录'
					},
				],
				loginstate: false,
				token: '',
				user: '',
				userName: localStorage.getItem('user_name'),
				userIdcard: localStorage.getItem('id_card'),
				mobile: localStorage.getItem('user_mobile'),
                userImg: localStorage.getItem('user_img'),
                createTime: localStorage.getItem('create_time'),
				my_clazz_list: [],
				queryClazzParams: {
					pageNum: 1,
					pageSize: 10,
					year:null
				},
				my_clazz_total: 0,
				my_course_list:[],
				queryMyCourseParams: {
					pageNum: 1,
					pageSize: 6,
					year:null
				},
				my_course_total: 0,
				notice_list:[],
				queryNoticeParams: {
					pageNum: 1,
					pageSize: 10,
				},
				notice_total: 0,
				//查询我的证书
				cerfit_list:[],
				queryCerfitParams: {
					pageNum: 1,
					pageSize: 10,
				},
				cerfit_total: 0,
				//订单
				order_list:[],
				queryOrderParams: {
					pageNum: 1,
					pageSize: 10,
					year:null
				},
				order_total: 0,
				isShowMultiple: false,
                isShowMyPay:false,
				payCodeUrl: '',
				invoice:{
					id:'',
					invoice_payable:'',
					invoice_tax_number:'',
					invoice_receive_people:'',
					invoice_receive_address:''
				},
				clazzUser:{
				  id:'',
				  create_time:'',
				  user_name:'',
				  idcard:'',
				  clazz_name:'',
				},
				userPwd:{
					oldPassWd:'',
					newPassWd:'',
					snewPassWd:''
				},
				avatar:'',
                bmmc:'',
				bmjg:'',
				ggk_zxs:0,
				zyk_zxs:0,
				year:localStorage.getItem('year')

			};
		},
		mounted() {
			this.queryNoticeList();
			this.queryClazzList();
			//this.queryCertificateList();
			this.querymyOrderList();
			this.querymyCourseList();
		    this.queryClazzUserData();
			this.queryUserSchoolHours();
		},
	    methods: {
			showPercent(percent){
				if(percent == null || percent == ''){
					return 0;
				}
				return (parseFloat(percent)).toFixed(2);
			},
			closeClazzUser(clazzStudentId){
				cancelClazzStudentById(clazzStudentId).then(res => {
				   if(res.code == 200){
					    this.queryClazzList();
					}
				})
			},
			toCourseDetail(id) {
				var data = {
					id:id,
					year:localStorage.getItem('year')
				}
				queryClazzReportState(data).then(res => {
					var me = this;
					if(res.code == 200){
						if(res.state == '1'){
							me.$router.push({path:'/course/detail',query:{id:id}});
							return;
						}else{
							 me.$confirm('本课程您未报名，但您可以试看2分钟课程，也可直接前往个人中心报名学习!', '课程试学提示', {
							          distinguishCancelAndClose: true,
									  type:'warning ' ,
							          confirmButtonText: '试学',
							          cancelButtonText: '放弃'
							    }).then(() => {
									//跳转到试学
									me.$router.push({
										path: '/course/tryPlay',
										query: {
											courseId: id
										}
									});
							        //alert("试学！");
							    }).catch(action => {
							        console.log("取消所属")
							    });
						    
							//me.$message.error(res.msg);
							//return;
						}
					}
				})
			},
			setups(file) {
			  console.log(file);
			  const data=new FormData;
			  data.append("file",file.file);
			   uploadFile(data).then((response)  => {
				 this.userImg=response.fileName
				 console.log(this.userImg)
			   }).then(this.updates)
			},
			updates(){
				  const  data={
					userImg:this.userImg
				  }
				  updateUser(data).then(response => {
					console.log(response)
					localStorage.setItem('user_img', response.user.userImg);
				  });
			},
			submitCreditHours() {
				var time = {
					year: this.year
				}
				this.$alert('您正在提交' + this.year + '年学时', {
				    confirmButtonText: '确认提交',
					title:'重要提示',
				    callback: action => {
						var cert = {
							year:localStorage.getItem('year')
						}
						submitStudyHonours(cert).then(response => {
							if(response.code == 200){
								this.$message.success('提交成功！');
								//var obj = JSON.parse(response.info);
								/* if (obj.code == 0) {
									this.$message.success('提交成功！');
									return;
								} else {
									this.$message.error(obj.msg);
								} */
							}else{
								this.$message.error(response.msg);
								return;
							}
			
						});
				    }
				});
				
			},				
			getAvatarUrl(avatarUrl) {
				  console.log("头像url:", avatarUrl);
			},
			startReport(id) {
				var obj = {
					id: id,
					year:localStorage.getItem('year')
				}
				startReport(obj).then(res => {
					if (res.code == 200) {
						this.$message.success('报名成功');
						this.queryClazzList();
						return;
					} else {
						this.$message.fail(res.msg);
					}
				})
			},
			endReport(id) {
				this.queryClazzList();
				this.isShowMultiple = false;
			},
			updatePassword(){
				if (this.userPwd.oldPassWd == null || this.userPwd.oldPassWd == '') {
					this.$message.error('请输入旧密码');
					return;
				}
				if (this.userPwd.newPassWd == null || this.userPwd.newPassWd == '') {
					this.$message.error('请输入新密码');
					return;
				}
				if (this.userPwd.snewPassWd == null || this.userPwd.snewPassWd == '') {
					this.$message.error('输入确认密码');
					return;
				}
				if (this.userPwd.newPassWd != this.userPwd.snewPassWd) {
					this.$message.error('二次输入密码不一致');
					return;
				}
				this.userPwd.snewPassWd = encrypt(this.userPwd.snewPassWd);
				this.userPwd.newPassWd = encrypt(this.userPwd.newPassWd);
				updatePassword(this.userPwd).then(res => {
					console.log("24" + JSON.stringify(res));
					if (res.code == 200) {
						this.$message.success('修改密码成功，请重新登录');
						localStorage.clear()
						this.$router.push('/user/login');
						console.log("12" + res.msg);
					}else{
						this.$message.error(res.msg);
						this.userPwd.oldPassWd ='';
						this.userPwd.newPassWd ='';
						this.userPwd.snewPassWd ='';
					}
				})
			},
			//创建支付二维码
			createPayCodeUrl(id,clazzName,price) {
				var obj = {
					id: id,
					year:localStorage.getItem('year')
				}
				//this.checkOrderIsPay(id);
				this.bmmc = clazzName;
				this.bmjg = price;
				createPayCodeUrl(obj).then(res => {
					console.log("24" + JSON.stringify(res));
					if (res.code == 200) {
						this.payCodeUrl =res.msg;
						this.isShowMultiple = true;
					}else{
						this.$message.error(res.mclazzNamesg);
					}
				})
			},
			checkOrderIsPay(id){
				var me = this;
				var obj = {
					id: id,
					year:localStorage.getItem('year')
				}
				var timer = setInterval(function(){
					checkOrderIsPay(obj).then(res => {
						console.log("24" + JSON.stringify(res));
						if (res.code == 200) {
							if(res.state == '1'){
								me.isShowMultiple = false;
								me.queryClazzList();
								clearInterval(timer);
								me.$message.success('缴费成功,开始学习吧');
							}
						}
					})
				},2000);
			
			},
			  //发票申请
			myPayInvoice(id) {
				this.isShowMyPay = true;
			},
			closeOpo(id) {
				this.isShowMyPay = false;
			},
			submitInvoice(id){
				if(this.invoice.invoice_payable == null || this.invoice.invoice_payable == ''){
					this.$message.error('发票抬头不能为空');
					return;
				}
				if(this.invoice.invoice_tax_number == null || this.invoice.invoice_tax_number == ''){
					this.$message.error('税号不能为空');
					return;
				}
				if(this.invoice.invoice_receive_people == null || this.invoice.invoice_receive_people == ''){
					this.$message.error('发票收件人不能为空');
					return;
				}
				if(this.invoice.invoice_receive_address == null || this.invoice.invoice_receive_address == ''){
					this.$message.error('发票收件把地址不能为空');
					return;
				}
				this.invoice.id =id
				submitInvoice(this.invoice).then(res => {
					console.log("4566"+res);
					if(res.code == 200){
						this.querymyOrderList();
						this.closeOpo();
						this.$message.success('申请成功!');
					}else{
						this.$message.error('申请失败');
					}
				})
			},
			querymyCourseList(){
				this.queryMyCourseParams.year = localStorage.getItem('year');
				querymyCourseList(this.queryMyCourseParams).then(res => {
					console.log("4566"+res.rows);
					var list = res.rows;
					this.my_course_list = [];
					this.my_course_list = res.rows;
					//console.log(JSON.stringify(this.my_course_list))
					this.my_course_total = res.total;
				})
			},
			querymyOrderList(){
				this.queryOrderParams.year = localStorage.getItem('year');
				querymyOrderList(this.queryOrderParams).then(res => {
					var list = res.rows;
					this.order_list = [];
					this.order_list = res.rows;
					this.order_total = res.total;
				})
			},
			queryUserSchoolHours(){
				var parm = {
					year:localStorage.getItem('year')
				}
				queryUserSchoolHours(parm).then(res => {
					if(res.code == 200){
						this.ggk_zxs = res.ggk_zxs;
						this.zyk_zxs = res.zyk_zxs;
					}else{
						this.ggk_zxs = 0.00;
						this.zyk_zxs = 0.00;
					}
				})
			},
			queryClazzUserData(){
				queryClazzUserInfo().then(res => {
				  this.clazzUser.id = res.data[0].id;
				  this.clazzUser.create_time = res.data[0].createTime;
				  this.clazzUser.user_name = res.data[0].userName;
				  this.clazzUser.idcard = res.data[0].idcard;
				  this.clazzUser.clazz_name = res.data[0].clazzName;
				})
			},
			queryNoticeList(){
				queryNoticeList(this.queryNoticeParams).then(res => {
					var list = res.rows;
					this.notice_list = [];
					this.notice_list = res.rows;
					this.notice_total = res.total;
				})
			},		
			queryClazzList() {
				this.queryClazzParams.year = localStorage.getItem('year');
				queryClazzList(this.queryClazzParams).then(res => {
					var list = res.rows;
					this.my_clazz_list = [];
					this.my_clazz_list = res.rows;
					this.my_clazz_total = res.total;
				})
			},
			queryCertificateList(){
				queryCertificateList(this.queryCerfitParams).then(res => {
					var list = res.rows;
					this.cerfit_list = [];
					this.cerfit_list = res.rows;
					this.cerfit_total = res.total;
				})
			},		
			pageCourseChange(currentPage){
				console.log(currentPage);
				this.queryMyCourseParams.pageNum = currentPage;
				// ajax请求, 向后台发送 currentPage, 来获取对应的数据
				this.querymyCourseList();
			},
			pageCerfitChange(currentPage){
				console.log(currentPage);
				this.queryCerfitParams.pageNum = currentPage;
				// ajax请求, 向后台发送 currentPage, 来获取对应的数据
				this.queryCertificateList();
			},
			
			pageNoticeChange(currentPage){
				console.log(currentPage);
				this.queryNoticeParams.pageNum = currentPage;
				// ajax请求, 向后台发送 currentPage, 来获取对应的数据
				this.queryNoticeList();
			},		
			pageClazzChange(currentPage) {
				console.log(currentPage);
				this.queryClazzParams.pageNum = currentPage;
				// ajax请求, 向后台发送 currentPage, 来获取对应的数据
				this.queryClazzList();
			},
			queryLoginState() {
				var token = localStorage.getItem('token');
				if (token == null || token == '') {
					this.loginstate = false;
					return;
				} else {
					queryLoginState({}).then(res => {
						if (res.code == 401) {
							localStorage.clear();
							this.loginstate = false;
							this.$router.push('/login');
							return;
						}
						if (res.code == 200) {
							this.loginstate = true;
							return;
						}
					})
				}
			},		
			toright(index, name) {
				this.activeindex = index;
				this.name = name;
			},
			toisgread() {
				this.isdread = !this.isdread;
			},
			offic(index) {
				console.log(index);
				this.such = index;
			},
			toourdetail() {
				this.alterour = true;
			},
			toourdetails() {
			   this.alterour = false;
			},		

		},

	};
</script>


<style lang="less" scoped>
	.model2 {
		position: fixed;
		z-index: 999;
		background-color: rgba(0, 0, 0, .5);
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		display: flex;
		justify-content: center;
		align-items: center;

		.modelFixed {
			width: 500px;
			height: auto;
			padding: 60px 0;
			background: #ffffff;
			border-radius: 12px;
			box-shadow: 0 0 25px rgba(0, 0, 0, .5);
			position: relative;
			display: flex;
			flex-flow: column;
			justify-content: center;
			align-items: center;

			span {
				font-size: 26px;
				font-weight: bold;
				text-align: center;
				padding: 0 0 20px 0;

				font {
					font-size: 40px;
					font-weight: normal;
					color: #ff3300;
				}
			}

			p {
				font-size: 16px;
				text-align: center;
				padding: 20px 0 0 0;
			}

			a {
				position: absolute;
				right: 15px;
				top: 15px;
				width: 34px;
				height: 34px;
				line-height: 32px;
				background: #e1e1e1;
				border-radius: 100px;
				text-align: center;
				font-size: 26px;
				cursor: pointer;
			}
		}
    .myPayInvoice{
      width: 720px;
      height: auto;
      padding: 60px 0;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 0 25px rgba(0, 0, 0, .5);
      position: relative;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      p{
        display: flex;
        width: 80%;
        justify-content: space-between;
        align-items: center;
        line-height: 40px;
        border-bottom: 1px dotted #ccc;
        font-size: 14px;
        input{
          width:50%;
          height: 30px;
          line-height: 30px;
          border: none;
          background: #f1f1f1;
          border-radius: 4px;
          padding:0 10px;
        }
      }
      div{
        background: #fafafa;
        width: calc(80% - 30px);
        height: auto;
        font-size: 14px;
        padding:10px 15px;
        margin:10px 0 0 0;
        color: #ff3d3d;
      }
      .invoiceBtn{
        padding: 5px 15px;
        font-size: 14px;
        margin:10px 0 0 0;
        cursor: pointer;
      }
      a {
        position: absolute;
        right: 15px;
        top: 15px;
        width: 34px;
        height: 34px;
        line-height: 32px;
        background: #e1e1e1;
        border-radius: 100px;
        text-align: center;
        font-size: 26px;
        cursor: pointer;
      }
    }
	}

	// 公共
	.navtab {
		width: 1280px;
		margin: 0 auto;
	}

	.color {
		color: #2961EF !important;
	}

	.ignore {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	// 个人列表
	.listbox {
		display: flex;

		.leftbox {
			width: 15%;
			margin-top: 23px;

			.list {
				cursor: pointer;
				margin-bottom: 53px;


				img {
					width: 18px;
					height: 21px;
					margin-right: 13px;
					vertical-align: middle;
				}

				span {
					vertical-align: middle;
					font-size: 20px;
					color: #333333;
				}

				.active {
					color: #2961EF;
				}
			}
		}

		.rightbox {
			width: 85%;
			padding: 23px 0 0 30px;
			border-left: 1px dashed rgba(112, 112, 112, 0.28);

			.name {
				font-size: 18px;
				color: #333333;
				width: 98px;
				text-align: center;
				border-bottom: 1px solid #2961EF;
				padding-bottom: 17px;
			}

			.nameindex {
				span {
					display: inline-block;
					font-size: 18px;
					color: #333333;
					width: 98px;
					text-align: center;
					padding-bottom: 17px;
				}

				.isspan {
					padding-bottom: 17px;
					border-bottom: 1px solid #2961EF;
				}
			}

			.content {
				width: 100%;
				border-top: 1px dashed #dcdcdc;
				padding-top: 27px;
				display: flex;
				flex-wrap: wrap;

				// 个人中心
				.answer {
					width: 28.5%;
					padding: 18px;
					background: #f7f8fa;
					border-radius: 5px 5px 5px 5px;
					margin-bottom: 22px;
					margin-right: 2%;

					&:nth-child(3n) {
						margin-right: 0;
					}

					.img {
						font-size: 18px;
						color: #777777;

						img {
							width: 22px;
							height: 17px;
						}
					}

					.cont {
						font-size: 18px;
						font-weight: 600;
						color: #333333;
						margin: 13px 0;
					}

					.detail {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-top: 17px;

						.time {
							font-size: 16px;
							color: #777777;
						}

						.todetail {
							font-size: 16px;
							color: #555555;
						}
					}
				}

				// 购物车
				.courbox {
					border-radius: 5px 5px 5px 5px;
					border: 1px solid #f1f1f1;
					padding: 10px 10px 0;
					width: 20.4%;
					margin-bottom: 18px;
					position: relative;
					margin-right: 3%;

					&:nth-child(4n) {
						margin-right: 0;
					}

					.play {
						position: absolute;
						top: 15px;
						left: 15px;
						background: rgba(255, 106, 0, 0.8);
						border-radius: 5px 5px 5px 5px;
						padding: 3px 10px;
						font-size: 14px;
						color: #ffffff;

						img {
							margin-right: 5px;
						}
					}

					.hour {
						position: absolute;
						top: 15px;
						right: 15px;
						background: rgba(255, 106, 0, 0.8);
						border-radius: 5px 5px 5px 5px;
						padding: 3px 10px;
						font-size: 14px;
						color: #ffffff;
					}

					img {}

					.tit {
						font-size: 14px;
						color: #383838;
						margin-bottom: 25px;
					}

					.bottom {
						height: 40px;
						border-top: 1px solid #f1f1f1;

						img {
							vertical-align: middle;
							width: 21px;
							height: 21px;
							border-radius: 50%;
						}

						.person {
							vertical-align: middle;
							line-height: 41px;
							padding: 0 15px 0 10px;
							font-size: 14px;
							color: #888888;

							&::after {
								content: '';
								border: 1px solid rgba(112, 112, 112, 0.3);
								height: 2px;
								margin-left: 10px;
							}
						}

						.num {
							vertical-align: middle;
							line-height: 41px;
							font-size: 14px;
							color: #888888;
						}

						.money {
							vertical-align: middle;
							line-height: 41px;
							font-size: 14px;
							color: #2961EF;
							float: right;
						}
					}
				}

				// 我的课程
				.couse {
					display: flex;
					justify-content: space-between;
					align-items: center;
					flex-wrap: wrap;
          width: 100%;

					.cousebox {
						width: 47%;
						margin-bottom: 23px;
						background: #f7f8fa;
						border-radius: 5px 5px 5px 5px;
						border: 1px solid #f1f1f1;
						padding: 11px;
						display: flex;
						align-items: center;

						img {
							width: 220px;
							height: 140px;
						}

						.imgright {
							width: calc(100% - 220px);
							margin-left: 12px;

							.name1 {
								font-size: 22px;
								color: #333333;
							}

							.student {
								line-height: 40px;
								margin: 18px 0;
								font-size: 16px;
								color: #777777;
							}

							.conteal {
								float: right;
								font-size: 16px;
								color: #2961EF;
								vertical-align: middle;

								img {
									vertical-align: middle;
									width: 18px;
									height: 18px;
								}
							}
						}
					}
				}

				// 我的班级
				.listbox {
					padding: 11px;
					display: inline-block;
					align-items: center;
					background: #f7f8fa;
					display: flex;
					justify-content: space-between;
					align-items: center;
					position: relative;

					img {
						width: 220px;
						height: 140px;
						vertical-align: middle;
						margin-right: 25px;
					}

					.titlebox {
						padding-right: 10px;
					}

					.title {
						font-size: 22px;
						color: #333333;
						font-weight: 400;

						span {
							padding: 3px 14px;
							font-size: 14px;
							border-radius: 5px 5px 5px 5px;
						}

						.color1 {
							border: 1px solid #b4d4f8;
							color: #2961EF;
							background: rgba(180, 212, 248, 0.5);
							margin: 0 7px 0 16px;
						}

						.color2 {
							border: 1px solid #f8d1b4;
							color: #2961EF;
							background: rgba(248, 209, 180, 0.5);
						}

						.color3 {
							font-size: 16px;
							font-weight: 600;
							color: #003433;
							padding: 0;
							margin-left: 235px;
						}

						.color4 {
							padding: 0;
							font-size: 24px;
							font-weight: 600;
							color: #2961EF;
						}
					}

					.time {
						display: inline-block;
						font-size: 14px;
						color: #888888;
						position: relative;
						margin: 10px 0 14px;

						span {
							vertical-align: middle;
							padding: 0 20px;
							height: 10px;
							border-right: 1px solid rgba(119, 119, 119, 0.82);

							// &::after {
							//     content: '';
							//     height: 18px;
							//     width: 1px;
							//     position: absolute;
							//     right: 10px;
							//     top: 0;
							// }
							&:nth-child(1) {
								padding: 0 20px 0 0;
							}

							&:nth-child(3) {
								border-right: none;
							}
						}
					}

					.tent {
						font-size: 14px;
						font-weight: 300;
						color: #777777;
						width: 720px;
						text-indent: 2em;
					}

					.down {
						position: absolute;
						right: 0;
						bottom: 18px;
						width: 25px;
						height: auto;
					}
				}

				.cousegrade {
					padding-top: 20px;
					border-top: 1px dashed rgba(220, 220, 220, 0.8);
					width: 100%;
					background: #f7f8fa;
					display: flex;
					flex-wrap: wrap;

					.cousebox {
						width: 30%;
						margin: 0 10px 0;
						margin-bottom: 23px;
						background: #ffffff;
						border-radius: 5px 5px 5px 5px;
						padding: 11px;
						display: flex;
						align-items: center;

						&:nth-child(3n) {
							margin-left: 0;
							margin-right: 0;
						}

						&:nth-child(2n) {
							margin-left: 0;
						}

						img {
							width: 220px;
							height: 140px;
						}

						.imgright {
							width: 100%;
							margin-left: 12px;

							.name1 {
								font-size: 22px;
								color: #333333;
							}

							.student {
								line-height: 40px;
								margin: 18px 0;
								font-size: 16px;
								color: #777777;
							}

							.conteal {
								float: right;
								font-size: 16px;
								color: #2961EF;
								vertical-align: middle;

								img {
									vertical-align: middle;
									width: 18px;
									height: 18px;
								}
							}
						}
					}
				}

				// 我的考试
				.exerise {
					display: flex;
					flex-wrap: wrap;
					margin: 35px auto 56px;

					.exerlistbox {
						width: 29%;
						margin-bottom: 27px;
						// height: 145px;
						background: #fafafa;
						border-radius: 0px 0px 5px 5px;
						border-top: 3px solid #2961EF;
						margin-right: 1%;
						padding: 17px;

						&:nth-child(3n) {
							margin-right: 0;
						}

						.exername {
							font-size: 18px;
							font-weight: 600;
							color: #333333;
						}

						.num {
							height: 35px;
							line-height: 35px;
							background: #ffffff;
							border-radius: 5px 5px 5px 5px;
							font-size: 15px;
							color: #999999;
							padding: 0 10px;
							margin: 15px 0;

							span {
								height: 35px;
								line-height: 35px;
								margin: 0 0 0px 40px;
								position: relative;

								&::before {
									content: '';
									position: absolute;
									left: -20px;
									top: 2px;
									display: inline-block;
									width: 1px;
									height: 16px;
									background: #999999;
								}
							}
						}

						.time {
							padding: 0 10px;
							font-size: 15px;
							color: #888888;

							span {
								cursor: pointer;
								font-size: 16px;
								color: #2961EF;
								float: right;
							}
						}
					}
				}
			}

			// 我的成绩
			.mygrade {
				width: 100%;
				border-top: 1px dashed #dcdcdc;
				padding-top: 27px;

				.offical {
					width: 100%;

					.table {
						height: 60px;
						width: 100%;
						background: #fafafa;

						span {
							display: inline-block;
							line-height: 60px;
							text-align: center;
							font-size: 20px;
							color: #333333;
							border-right: 1px solid rgba(112, 112, 112, 0.14);

							img {
								margin-right: 11px;
								width: 14px;
								height: auto;
							}

							&:nth-child(1) {
								width: 50%;
							}

							&:nth-child(2) {
								width: 24%;
							}

							&:nth-child(3) {
								width: 24%;
								border-right: 0;
							}
						}
					}

					.tr {
						background: #ffffff;
						border-bottom: 1px solid rgba(112, 112, 112, 0.14);

						span {
							border-right: 1px solid rgba(112, 112, 112, 0.14);
						}

						span:nth-child(1) {
							text-align: left;
							width: 45%;
							padding-left: 5%;
							font-size: 16px;
							color: #777777;
						}

						span:nth-child(2) {
							width: 24%;
							font-size: 16px;
							color: #444444;
						}

						span:nth-child(3) {
							width: 24%;
							font-size: 16px;
							color: #2961EF;
							border-right: 0;
						}
					}
				}
			}


			// 我的消息
			.messages {
				border-top: 1px dashed #dcdcdc;
				padding-top: 5px;

				.messagesList {
					height: auto;
					padding: 15px 30px;
					background: #fafafa;
					border-radius: 6px;
					border: 1px solid #f1f1f1;
					box-shadow: 5px 5px 15px rgba(0, 0, 0, .05);
          margin: 20px 0 0 0;

					.messagesTitle {
						font-size: 18px;
						padding: 5px 0;
					}

					.messagesTime {
						font-size: 14px;
						color: #b1b1b1;
						padding: 5px 0;
					}

					.messagesCon {
						font-size: 14px;
						color: #383838;
						padding: 5px 0;
					}
				}
			}

			// 我的订单
			.myPay {
				border-top: 1px dashed #dcdcdc;
				padding-top: 27px;
        .myPayList{
          width: calc(50% - 58px);
          height: auto;
          background: #fafafa;
          padding:10px 25px;
          border: 1px solid #f1f1f1;
          border-radius: 6px;
          p{
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            line-height: 44px;
            border-bottom: 1px dotted #ccc;
          }
          div{
            text-align: right;
            padding: 10px 0 20px 0;
            a{
              display: inline-block;
              width: auto;
              height: 30px;
              line-height: 30px;
              padding: 0 15px;
              background: #fff;
              border: 1px solid #e1e1e1;
              border-radius: 4px;
              color: #0b7eff;
              cursor: pointer;
            }
          }
        }
			}


			// 我的证书
			.certificate {
				border-top: 1px dashed #dcdcdc;
				padding-top: 27px;
				display: flex;
				flex-wrap: wrap;

				.cerlist {
					border-radius: 5px 5px 5px 5px;
					background: #f7f8fa;
					padding: 17px 17px 17px 24px;
					margin-right: 15px;
					margin-bottom: 28px;

					&:nth-child(3n) {
						margin-right: 0;
					}

					.title {
						font-size: 18px;
						font-weight: 600;
						color: #333333;
						margin-bottom: 10px;
					}

					.time {
						font-size: 16px;
						color: #777777;

						img:nth-child(1) {
							margin-left: 80px;
							margin-right: 12px;
						}
					}
				}
			}

			// 培训信息
			.apply {
				border-top: 1px dashed #dcdcdc;
				padding-top: 27px;

				.listbox {
					padding: 11px;
					display: inline-block;
					align-items: center;
					background: #f7f8fa;
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 28px;

					.secodebox {
						display: flex;
					}

					img {
						margin: 0 auto;
						width: 220px;
						height: 140px;
						vertical-align: middle;
						margin-right: 20px;
					}

					.title {
						font-size: 22px;
						color: #333333;
						font-weight: 400;

						span {
							padding: 3px 14px;
							font-size: 14px;
							border-radius: 5px 5px 5px 5px;
						}

						.color1 {
							border: 1px solid #b4d4f8;
							color: #2961EF;
							background: rgba(180, 212, 248, 0.5);
							margin: 0 7px 0 16px;
						}

						.color2 {
							border: 1px solid #f8d1b4;
							color: #2961EF;
							background: rgba(248, 209, 180, 0.5);
						}
					}

					.time {
						display: inline-block;
						font-size: 14px;
						color: #888888;
						position: relative;
						margin: 10px 0 14px;

						span {
							vertical-align: middle;
							padding: 0 20px;
							height: 10px;
							border-right: 1px solid rgba(119, 119, 119, 0.82);

							// &::after {
							//     content: '';
							//     height: 18px;
							//     width: 1px;
							//     position: absolute;
							//     right: 10px;
							//     top: 0;
							// }
							&:nth-child(1) {
								padding: 0 20px 0 0;
							}

							&:nth-child(3) {
								border-right: none;
							}
						}
					}

					.tent {
						width: 610px;
						font-size: 14px;
						font-weight: 300;
						color: #777777;
						text-indent: 0em;
					}

					.bottom {
						width: 180px;

						img {
							width: 37px;
							height: auto;
							display: block;
							margin: 0 auto;
							margin-bottom: 10px;
						}

						font-size: 16px;
						color: #2961EF;
						text-align: center;

						.agin {
							width: 150px;
							height: 35px;
							line-height: 35px;
							text-align: center;
							background: #2961EF;
							border-radius: 18px 18px 18px 18px;
							font-size: 16px;
							color: #ffffff;
							margin: 10px auto 0;
						}

						.fees {
							background: #62a616;
						}
					}

					.coloragin {
						color: #f70000;
					}

					.colorfees {
						color: #62a616;
					}
				}
			}

			// 个人信息
			.ourbox {
				width: 100%;
				display: flex;
				justify-content: space-between;

				.ourleft {
					display: flex;
					align-items: center;

					img {
						width: 150px;
						height: 150px;
						border-radius: 5px 5px 5px 5px;
						margin-right: 35px;
					}

					.ourleftlist {
						font-size: 16px;
						color: #333333;

						div {
							line-height: 40px;
						}
					}
				}

				.ourright {
					cursor: pointer;
					width: 187px;
					height: 50px;
					line-height: 50px;
					text-align: center;
					background: #2961EF;
					border-radius: 33px 33px 33px 33px;
					font-size: 16px;
					color: #ffffff;
				}

				// 个人信息修改
				.alterour {
					width: 100%;
					display: flex;
					justify-content: space-between;

					.head {
						cursor: pointer;

						img {
							width: 150px;
							height: 150px;
							display: block;
							margin-bottom: 17px;
						}

						font-size: 16px;
						text-align: center;
						color: #333333;
						margin-right: 34px;
					}

					.headright {
						width: 100%;

						.list {
							width: 100%;
							font-size: 16px;
							color: #333333;
							margin-bottom: 25px;
              display: flex;
              justify-content: space-between;
              align-items: center;


							input {
								width: 87%;
								padding-left: 22px;
								height: 45px;
								background: #fafafa;
								border-radius: 5px 5px 5px 5px;
								border: 1px solid #f1f1f1;
							}
						}

						.submit {
							width: 187px;
							height: 50px;
							line-height: 50px;
							text-align: center;
							background: #2961EF;
							border-radius: 33px 33px 33px 33px;
							font-size: 16px;
							color: #ffffff;
							float: right;
						}
					}
				}
			}
		}
	}

	.zhengshulist span {
		display: flex;

		a {
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 10px 10px 0 0;
			padding: 5px 10px;
			background: #ffffff;
			border: 1px solid #e1e1e1;
			border-radius: 4px;
      cursor:not-allowed ;

			img {
				margin: 0 5px 0 0 !important;
			}
		}
	}
</style>
